import PollCreation from '@/shared-components/forms/add-board-content/board-text-body/add-element/add-polls/PollCreation';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

export default function PollManager({
  isPollModalOpen,
  setIsPollModalOpen,
  pollToEdit,
  setPollToEdit,
  dispatch,
}) {
  const handleClose = () => {
    setIsPollModalOpen(false);
    setPollToEdit(null);
  };

  const handleDelete = () => {
    if (!pollToEdit) return;
    dispatch({ type: 'BLOCK_REMOVED', blockType: 'post_polls', id: pollToEdit.pollId });
    handleClose();
  };

  // 4) Create a new poll
  const handlePollSubmit = (data) => {
    dispatch({
      type: 'BLOCK_CREATED',
      blockType: 'post_polls',
      data: { question: data.question, options: data.options },
    });
    setIsPollModalOpen(false);
  };

  // 5) Update an existing poll
  const handlePollUpdate = (updated) => {
    if (!pollToEdit) return;
    dispatch({ type: 'POLL_UPDATED', id: pollToEdit.pollId, changes: updated });

    setPollToEdit(null);
    setIsPollModalOpen(false);
  };

  // 7) Only render the creation/edit modal
  return (
    <>
      {isPollModalOpen && (
        <GenericPopup
          className="poll-quiz-creation-popup remove-scrollbar"
          open={isPollModalOpen}
          opacity
          onBackgroundClick={handleClose}
        >
          {/*
              PollCreation expects options to be simple strings.
              If this poll has already gathered votes, its options
              look like { text, votes }.  Strip them back to strings.
           */}
          <PollCreation
            initialPollData={
              pollToEdit
                ? {
                  ...pollToEdit,
                  options: pollToEdit.options.map(o =>
                    typeof o === "string" ? o : o.text
                  )
                }
                : null
            }
            onSubmit={pollToEdit ? handlePollUpdate : handlePollSubmit}
            onClose={handleClose}
            onDelete={pollToEdit ? handleDelete : undefined}
          />
        </GenericPopup>
      )}
    </>
  );
}
